<template>
  <div>
    <FiscalYears />
    <br>
    <Simulation/>
    <br>
    <br>
    <div>
      <h3>Recalcular BCEI y Repuestos Críticos Oficiales</h3>
      <br>
      <fs1 tag="p">Por este medio se podrá recalcular los BCEI y repuestos críticos oficiales en Plataforma Asset Integrity de acuerdo al año fiscal en curso. Este proceso también involucra aquellos BCEI y repuestos en proceso de aprobación vía workflow (solicitudes en proceso), simulados, históricos desactivados.</fs1>
      <fs1 tag="p">El botón “REVISAR” permite visualizar aquellos BCEI y repuestos que generarían un cambio en el resultado de su análisis en base al Fiscal Year anterior.</fs1>
      <fs1 tag="p">El botón “CAMBIAR” permite efectuar la actualización de los BCEI y repuestos en base al nuevo Fiscal Year vigente.</fs1>
    </div>
    <div style="text-align:center;margin-top:40px">
      <v-btn color="" @click="check">
        <span>Revisar</span>
      </v-btn>

      <v-btn color="primary" @click="comfirmDialog = true"  v-if="myPermissions.includes(16)">
        <v-icon small>warning</v-icon>
        <span>Cambiar</span>
      </v-btn>
    </div>
		<v-dialog persistent v-model="changeDialog" width="1000">
			<v-card class="pa-20 textAlignCenter">
				<h3 v-if="changeRes.discharge_flag_warning===false">Paso Intermedio de recálculo de Año Fiscal {{changeRes.fiscal_year}}</h3>
				<h3 v-else-if="changeRes.discharge_flag_warning===true">Recálculo de Año Fiscal {{changeRes.fiscal_year}} ha sido aplicado</h3>
        <h3 v-else>Se cambio</h3>
        <br>
        <div style="text-align: left;">
          <p v-if="changeRes.discharge_flag_warning===false">
            Los siguientes BCEI y repuestos se han marcado para indicar que tendrán un MFL menor a 3. Gatillar nuevamente este proceso re-calculará todos los BCEI y repuesto en plataforma incluyendo aquellos que se encuentren en workflow de aprobación.
          </p>
          <p v-if="changeRes.discharge_flag_warning===true">
            Se han recalculado todos los BCEI y repuestos aprobados y en workflow de aprobación en plataforma de acuerdo a los valores de EBIT del año fiscal {{changeRes.fiscal_year}}. El listado que se muestra a continuación son todos los BCEI y repuestos que ahora tienen un MFL menor a 3.
          </p>
          <div>
            <strong>Año Fiscal aplicado:</strong>
            <span>{{changeRes.fiscal_year}}</span>
          </div>
          <strong>BCEI</strong>
          <rev_ca :items="changeRes.discharge_critical_assets"/>
          <br>
          <strong>Repuestos (CSP / RI)</strong>
          <rev_sp :items="changeRes.discharge_spare_parts"/>
        </div>
        <br>
				<div>
					<v-btn color="secondary" @click="close_change()">
						<span>Cerrar</span>
            <span v-if="close_change_and_reload">
              {{' y recargar'}}
            </span>
					</v-btn>
				</div>
			</v-card>
		</v-dialog>

		<v-dialog persistent v-model="checkDialog" width="1000">
			<v-card class="pa-20 textAlignCenter">
				<h3>Revisión</h3>
        <div style="text-align: left;">
          <p>
            A continuación, se muestra los cambios que aplicará la plataforma sobre la criticidad de los BCEI y Repuestos
          </p>
          <div>
            <strong>Año Fiscal aplicado:</strong>
            <span> {{checkList.fiscal_year}}</span>
          </div>
          <strong>BCEI</strong>
          <rev_ca :items="checkList.discharge_critical_assets"/>
          <br>
          <strong>Repuestos (CSP / RI)</strong>
          <rev_sp :items="checkList.discharge_spare_parts"/>
        </div>
        <br>
				<div>
					<v-btn color="secondary" @click="checkDialog = false">
						<span>Cerrar</span>
					</v-btn>
				</div>
			</v-card>
		</v-dialog>

		<v-dialog persistent v-model="comfirmDialog" width="400">
			<v-card class="pa-20 textAlignCenter">
				<h3>Advertencia</h3>
        <br>
        <div style="text-align: left;">
          Se realizará un re-cálculo de todos los BCEI y repuestos vigentes en plataforma de acuerdo a los nuevos valores de EBIT del Año Fiscal {{currentFY}}. Este es un proceso irreversible, ¿desea continuar?
        </div>
        <br>
				<div>

					<v-btn color="secondary" @click="comfirmDialog = false">
						<span>Cerrar</span>
					</v-btn>
					<v-btn color="primary"  @click="comfirm">
            <v-icon small>warning</v-icon>
						<span>Aceptar</span>
					</v-btn>
				</div>
			</v-card>
		</v-dialog>

  </div>
</template>

<script>
import { functionCheckDischargeParts, functionDischargeParts, helperGetCurrentFiscalYear } from '@/requests/ac';
import FiscalYears from '@/components/admin/FiscalYears.vue';
import Simulation from '@/components/admin/Simulation.vue';
import rev_ca from '@/components/tables/rev_ca.vue';
import rev_sp from '@/components/tables/rev_sp.vue';
export default {
  components:{ FiscalYears, Simulation, rev_ca, rev_sp },
  data() {
    return {
      currentFY:'',
      comfirmDialog: false,
      changeDialog: false,
      checkDialog:false,
      checkList: {
        discharge_spare_parts:[],
        discharge_critical_assets:[],
      },
      changeRes:{
        discharge_spare_parts:[],
        discharge_critical_assets:[],
      },
    };
  },
  computed:{
    close_change_and_reload(){ return this.changeRes.discharge_spare_parts.length && this.changeRes.discharge_critical_assets && this.changeRes.discharge_flag_warning===true}
  },
  async created() {
    if(!await this.assignAccess()) return;
    helperGetCurrentFiscalYear()
      .then(f => f && (this.currentFY = f.year))
      .catch(e => this.getError(e));
  },
  methods:{
    close_change(){
      this.changeDialog = false;
      if (this.close_change_and_reload) window.location.reload();
    },
    comfirm() {
      this.comfirmDialog = false;
      this.change();
    },
    async check() {
      this.setProgress({show:true,message:'Buscando...'});
      if(!await this.assignAccess()) return;
      functionCheckDischargeParts()
        .then(r => {
          this.setProgress({show:false});
          //console.log('check',{r});
          if (r && r.fiscal_year) {
            this.checkList = r;
            this.checkDialog = true;
          } else {
            this.getError(r)
          }
        })
        .catch(e => this.getError(e));
    },
    async change(){
      this.setProgress({show:true,message:'Procesando...'});
      if(!await this.assignAccess()) return;
      functionDischargeParts()
        .then(r => {
          this.setProgress({show:false});
          //console.log('functionDischargeParts',{r});
          if (r && r.fiscal_year) {
            this.changeRes = r;
            this.changeDialog = true;
          } else {
            this.getError(r)
          }
        })
        .catch(e => this.getError(e));
    },
  }
};
</script>
